import React from 'react'

import { Loader2, AlertTriangle } from 'lucide-react'

import { Location } from '@/core/api/entities/location'
import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'
import {
	Dialog,
	DialogContent,
	DialogTitle,
} from '@/shared/components/molecules/Dialog/dialog'

interface DeleteLocationModalProps {
	visible: boolean
	location: Location | null
	onClose: () => void
	onConfirm: () => void
	isDeleting: boolean
}

const DeleteLocationModal: React.FC<DeleteLocationModalProps> = ({
	visible,
	onClose,
	onConfirm,
	isDeleting,
}) => {
	const { t } = useTranslation('common')

	return (
		<Dialog open={visible} onOpenChange={onClose}>
			<DialogContent className="sm:max-w-[500px] p-0 gap-0 overflow-y-auto flex flex-col">
				{/* Header */}
				<div className="px-6 py-6 border-b">
					<DialogTitle className="text-2xl">
						{t('entities.location.delete.title')}
					</DialogTitle>
				</div>

				{/* Content */}
				<div className="px-6 py-6">
					<div className="flex flex-col items-center text-center space-y-4">
						<div className="h-12 w-12 rounded-full bg-destructive/10 flex items-center justify-center">
							<AlertTriangle className="h-6 w-6 text-destructive" />
						</div>
						<p className="text-sm text-muted-foreground">
							{t('entities.location.delete.description')}
						</p>
					</div>
				</div>

				{/* Footer */}
				<div className="px-6 py-6 border-t flex justify-end gap-3">
					<Button
						variant="outline"
						onClick={onClose}
						disabled={isDeleting}
						className="rounded-full"
					>
						{t('actions.cancel')}
					</Button>
					<Button
						variant="destructive"
						onClick={onConfirm}
						disabled={isDeleting}
						className="rounded-full"
					>
						{isDeleting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
						{t('actions.delete')}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default DeleteLocationModal
